<template>
  <v-container
    fluid
    grid-list-xs
    class="pa-0"
  >
    <v-layout
      v-if="loading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
    >
      <v-flex class="profile ">
        <v-card class="pa-2 text-xs-center max-shadow">
          <v-btn
            flat
            icon
            absolute
            right
            color="primary"
            @click="editEmployeeDialog = true"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <div>
            <avatar
              :text="employee.name"
              :size="120"
            />
            <div class="title grey--text text--darken-2 py-3">
              {{ employee.name }}
            </div>
          </div>
          <v-divider />
          <v-list
            dense
            class="pa-3"
          >
            <v-list-tile>
              <v-list-tile-action> <v-icon>phone</v-icon> </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ employee.phone }}
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action> <v-icon>email</v-icon> </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ employee.email }}
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon slot="activator">
                    domain
                  </v-icon>
                  <span>Designation</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ employee.designation }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <div class="d-flex">
            <v-btn
              flat
              color="primary"
              @click="disableEmployeeDialog = true"
            >
              Disable
            </v-btn>
            <v-btn
              flat
              color="error"
              @click="deleteEmployeeDialog = true"
            >
              Delete
            </v-btn>
          </div>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="pa-2 max-shadow">
          details
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="editEmployeeDialog"
      lazy
      max-width="600px"
    >
      <edit-employee
        :employee="deepClone(employee)"
        @update="employeeUpdated"
        @cancel="editEmployeeDialog = false"
      />
    </v-dialog>
    <v-dialog
      v-model="deleteEmployeeDialog"
      lazy
      max-width="600px"
    >
      <v-card class="max-shadow">
        <v-card-title primary-title>
          <div class="headline">
            Delete {{ employee.name }}
          </div>
        </v-card-title>
        <v-card-text>
          <div class="subheading">
            Do you want to delete <strong>{{ employee.name }}</strong>? Employee account will be deleted permanently from the Max server
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="primary"
            @click.stop="deleteEmployeeDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            flat
            color="primary"
            @click.stop="deleteEmployee"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="disableEmployeeDialog"
      lazy
      max-width="600px"
    >
      <v-card class="max-shadow">
        <v-card-title primary-title>
          <div class="headline">
            Disable {{ employee.name }}
          </div>
        </v-card-title>
        <v-card-text>
          <div class="subheading">
            Do you want to delete <strong>{{ employee.name }}</strong>? Employee can't access his/her account after its disabled
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="primary"
            @click.stop="disableEmployeeDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            flat
            color="primary"
            @click.stop="disableEmployee"
          >
            Disable
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="0"
      bottom
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';

import { firestore } from '@/firebase';

import avatar from '@/components/common/Avatar';
import EditEmployee from './EditEmployee';

export default {
  name: 'Employee',
  components: {
    avatar,
    EditEmployee
  },
  props: {
    eid: {
      type: String,
      default: null,
      required: true
    }
  },
  data() {
    return {
      employee: {},
      loading: true,
      editEmployeeDialog: false,
      deleteEmployeeDialog: false,
      disableEmployeeDialog: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'primary'
    };
  },
  created() {
    this.fetchEmployee();
  },
  methods: {
    fetchEmployee() {
      firestore
        .collection('tenants')
        .doc(this.$store.state.profile.cid)
        .collection('employees')
        .doc(this.eid)
        .get()
        .then(employeeSnapshot => {
          if (!employeeSnapshot.exists)
            throw new Error('Employee does not exists');
          const employee = employeeSnapshot.data();
          employee.id = this.eid;
          this.employee = employee;
          this.loading = false;
        })
        .catch(error => {
          this.snackbarMessage = error.message;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });
    },

    deepClone(obj) {
      return _cloneDeep(obj);
    },

    employeeUpdated() {
      this.fetchEmployee();
      this.editEmployeeDialog = false;
    },

    deleteEmployee() {
      this.deleteEmployeeDialog = false;
      firestore
        .collection('tenants')
        .doc(this.$store.state.profile.cid)
        .collection('employees')
        .doc(this.selectedEmployee.id)
        .delete();
      this.$router.back();
    },

    disableEmployee() {
      this.disableEmployeeDialog = false;
      firestore
        .collection('tenants')
        .doc(this.$store.state.profile.cid)
        .collection('employees')
        .doc(this.selectedEmployee.id)
        .update({
          disabled: true
        });
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.profile {
  max-width: 300px;
  min-width: 300px;
}
</style>
